<template>
  <section
    class="col-10 col-sm-6 col-md-4 px-2 mb-4 d-flex"
    :class="{ 'board-column-section--fullscreen': fullscreen }"
  >
    <div
      class="board-column bg-light border rounded w-100 d-flex flex-column"
      :class="{ 'board-column--page-scroll': fullscreen }"
    >
      <header class="d-flex align-items-center justify-content-between border-bottom p-4">
        <span class="h5 mb-0 text-dark font-weight-bolder">
          {{ column.status.name }}
        </span>
        <span class="badge badge-light px-3 py-2">
          {{ column.visits.length }}
        </span>
      </header>

      <div
        class="board-column__body flex-grow-1 overflow-auto position-relative p-4"
        :class="{ 'board-column__body--page-scroll': fullscreen }"
        :data-status-id="column.status.id"
      >
        <div
          class="service-visit-board-drop-zone service-visit-board-drop-zone--first position-relative"
          :class="{
            'service-visit-board-drop-zone--active': isVisitDropZone(column.status.id, 0)
          }"
        >
          <div class="service-visit-board-drop-line bg-primary rounded position-absolute w-100"></div>
        </div>

        <div
          v-for="(visit, index) in column.visits"
          :key="visit.id"
        >
          <div
            class="service-visit-board-card-wrap position-relative"
            :class="{
              'service-visit-board-card-wrap--disabled': isMovingVisit,
              'service-visit-board-card-wrap--dragging': isDraggedVisit(visit)
            }"
          >
            <ServiceVisitBoardCard
              :visit="visit"
              :item-statuses="itemStatuses"
              :can-move="canMoveVisit(visit)"
              :is-moving="isMovingVisit"
              @drag-start="$emit('visit-pointerdown', { visit, statusId: column.status.id, event: $event })"
              @task-updated="$emit('task-updated', $event)"
              @task-created="$emit('task-created', $event)"
              @tasks-reordered="$emit('tasks-reordered', $event)"
            />
          </div>
          <div
            class="service-visit-board-drop-zone position-relative"
            :class="{
              'service-visit-board-drop-zone--active': isVisitDropZone(column.status.id, index + 1)
            }"
          >
            <div class="service-visit-board-drop-line bg-primary rounded position-absolute w-100"></div>
          </div>
        </div>

        <div v-if="!column.visits.length" class="text-center p-4">
          {{ $t("SERVICE_VISITS.NO_VISITS_IN_STATUS") }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ServiceVisitBoardCard from "@/modules/service-visits/components/ServiceVisitBoardCard.vue";

export default {
  name: "ServiceVisitBoardColumn",
  components: {
    ServiceVisitBoardCard
  },
  props: {
    column: {
      type: Object,
      required: true
    },
    itemStatuses: {
      type: Array,
      default: () => []
    },
    isMovingVisit: {
      type: Boolean,
      default: false
    },
    canMoveVisit: {
      type: Function,
      required: true
    },
    isDraggedVisit: {
      type: Function,
      required: true
    },
    isVisitDropZone: {
      type: Function,
      required: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.board-column {
  max-height: calc(100vh - 230px);
  min-height: 0;
}

.board-column-section--fullscreen {
  flex: 0 0 360px;
  max-width: 360px;
  width: 360px;
}

.board-column__body {
  min-height: 0;
}

.board-column--page-scroll {
  max-height: none;
}

.board-column__body--page-scroll {
  overflow: visible !important;
}

.service-visit-board-card-wrap ::v-deep article {
  margin-bottom: 0 !important;
}

.service-visit-board-card-wrap--disabled {
  cursor: wait;
}

.service-visit-board-card-wrap--dragging {
  opacity: 0.72;
}

.service-visit-board-drop-zone {
  height: 16px;
}

.service-visit-board-drop-zone--first {
  height: 12px;
}

.service-visit-board-drop-line {
  height: 3px;
  left: 0;
  opacity: 0;
  top: 50%;
  transform: translateY(-50%);
}

.service-visit-board-drop-zone--active .service-visit-board-drop-line {
  opacity: 1;
}
</style>
